// extracted by mini-css-extract-plugin
export default {"badge-operator__container":"styles_badge-operator__container__NzWo9","badge-operator__text":"styles_badge-operator__text__TQ7jP"};